import { Button, Card, Checkbox, Col, ConfigProvider, DatePicker, Drawer, Form, Input, message, Modal, Row, Select, Space, Tag, Typography } from "antd";
import { Flex } from "antd/lib";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { createTimePlanShift, deleteTimePlanShift, getShiftOptions, updateTimeplanShift, updateTimePlanShiftAll } from "features/employee/services/employeeApi";
import { setShiftOptions, setIsLoading, setDepartmentOptions, setPositionOptions } from "features/employee/slices/employeeSlice";
import { setAttendanceSettingShifts } from "features/myDocument/slices/myDocumentSlice";
import { generateRandomString } from "utils/helper";
import { useDispatch, useSelector } from "react-redux";
import enUS from "antd/es/calendar/locale/en_US";
import thTh from "antd/es/calendar/locale/th_TH";
import FormItem from "antd/es/form/FormItem";
import { useForm } from "antd/es/form/Form";
import { getTimePlanShiftByCompany, getDepartmentOptions, getPositionOptions, getAttendanceSettingShift } from "../service/ScheduleService";
import { MY_TEAM, setIsShiftHrView, setTimePlanShiftByCompany } from "../slices/myteamSlice";
import useOptions from "features/masterData/hooks/useOptions";
import localeTh from 'antd/es/date-picker/locale/th_TH';
import localeEn from 'antd/es/date-picker/locale/en_US';
import MyTeamWorkScheduleTable from "components/table/MyTeamWorkScheduleTable";
import TableAntd from "components/elements/Table/Table";
import WorkscheduleFilterModal from "../components/WorkscheduleFilterModal";

const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

function useMyTeamWorkSchedule() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [form] = useForm();
  const [lang, setLang] = useState("en");

  const [openDrawer, setOpenDrawer] = useState({
    title: "",
    open: false
  })

  const [assignShift, setAssignShift] = useState({
    active: false,
    open: false,
    dateActive: null
  })

  const [openAll, setOpenAll] = useState(false)
  const [dateModal, setDateModal] = useState()
  const [dateListModal, setDateListModal] = useState()

  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const { timePlanShiftByCompany, isShiftHrView } = useSelector((state) => state?.[MY_TEAM]);
  const { shiftOptions } = useSelector(
    (state) => state.employee
  );
  const { departmentOptions,
    positionOptions, } = useSelector((state) => ({
      departmentOptions: state.employee.departmentOptions,
      positionOptions: state.employee.positionOptions,
    }));
  const attendanceSettingShifts = useSelector(
    (state) => state.myDocument.attendanceSettingShifts
  );

  const { employeeTypeOptions, getEmployeeTypeOptions } = useOptions();

  const [workScheduleList, setWorkScheduleList] = useState([])

  const [columns, setColumns] = useState([])

  const _INIT_COLUMN = {
    title: <div className="text-table">{t('employee.header')}</div>,
    dataIndex: "employeeName",
    key: "employeeName",
    width: "200px",
    fixed: "left",
  }


  const modifiedOptions = (options) =>
    options?.map((opt) => ({
      ...opt,
      label: i18n.language === "en" ? (opt?.nameEn ? opt?.nameEn : opt.name) : opt.name,
      value: opt.id,
    }));

  const useFetchOptions = (serviceFunction, companyId, groupType, dispatchFunction) => {
    const dispatch = useDispatch();
    useEffect(() => {
      const fetchData = async () => {
        dispatch(setIsLoading(true));
        try {
          const response = await serviceFunction({
            requestId: generateRandomString(),
            companyId,
            groupType,
          });
          dispatch(dispatchFunction(response.data));
        } catch (error) {
          console.error('Failed to fetch data:', error);
        } finally {
          dispatch(setIsLoading(false));
        }
      };

      if (companyId) {
        fetchData();
      }
    }, [companyId, serviceFunction, groupType, dispatchFunction, dispatch]);
  };
  const getAttendanceSettingShiftOptions = useCallback(async () => {
    try {
      const response = await getAttendanceSettingShift({
        companyId: currentCompany,
        employeeId: currentEmployee,
        actionId: currentEmployee,
      })
      dispatch(setAttendanceSettingShifts(response?.data))
    } catch (error) {
      message.error(t("common.error"))
    }
  }, [currentCompany,
    currentEmployee,
    currentEmployee])
  const modifiedAttendanceSettingShift = useMemo(() => {
    return attendanceSettingShifts?.map((opt) => ({
      ...opt,
      value: opt?.id,
      label: lang === 'en' ? opt?.shiftNameEn : opt?.shiftName
    }
    ))
  }, [lang, getAttendanceSettingShiftOptions, attendanceSettingShifts])

  useFetchOptions(getDepartmentOptions, currentCompany, "", setDepartmentOptions);
  useFetchOptions(getPositionOptions, currentCompany, "", setPositionOptions);
  const modifiedDepartmentOptions = useMemo(() => modifiedOptions(departmentOptions), [departmentOptions, i18n.language]);
  const modifiedPositionOptions = useMemo(() => modifiedOptions(positionOptions), [positionOptions, i18n.language]);
  const [searchName, setSearchName] = useState("")
  const [searchNo, setSearchNo] = useState("")
  const [searchDepartment, setSearchDepartment] = useState()
  const [searchPosition, setSearchPosition] = useState()
  const [searchNameModal, setSearchNameModal] = useState("")
  const [searchNoModal, setSearchNoModal] = useState("")
  const [searchDepartmentModal, setSearchDepartmentModal] = useState()
  const [searchPositionModal, setSearchPositionModal] = useState()
  const [pagination, setPagination] = useState({ page: 0, size: 10 })
  const [paginationModal, setPaginationModal] = useState({ page: 0, size: 10 })
  const [dataSourceModal, setDataSourceModal] = useState([])

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (selectedKeys, v1, v2) => {
    console.log("selectedKeys", selectedKeys, v1, v2);
    if (v1) {
      setSelectedRowKeys([...selectedRowKeys, selectedKeys]);
    } else {
      setSelectedRowKeys(selectedRowKeys.filter(o => o.id != selectedKeys.id));
    }
  };
  const onSelectChangeAll = (v1, v2, selectedKeys) => {
    console.log("selectedKeys", selectedKeys, v1, v2);
    if (v1) {
      setSelectedRowKeys([...selectedRowKeys, ...selectedKeys]);
    } else {
      setSelectedRowKeys(selectedRowKeys.filter(o => !selectedKeys.some(i => o.id == i.id)));
    }
  };

  const toParams = useCallback((params) => {
    const { pagination = {}, sortBy = [] } = params;
    const modifiedParams = {
      ...params,
      page: pagination.page || 0,
      size: pagination.pageSize || 10,
      sortBy: sortBy
        .filter((s) => s.order !== undefined)
        .map((s) => ({
          direction: s.order === "descend" ? "desc" : "asc",
          property: s.field,
        })),
    };
    return modifiedParams;

  }, [])

  const calendarCal = (date, assign) => {

    let count = date.daysInMonth();

    let columnCreate = [_INIT_COLUMN];

    for (let index = 0; index < count; index++) {
      let tempDate = date.clone();
      tempDate.add(index, "day")
      columnCreate.push({
        title: <Space direction="vertical">
          {tempDate.format(i18n.language == 'th' ? "dd" : "ddd")}
          {(index + 1)}
        </Space>,
        dataIndex: (index + 1),
        value: tempDate,
        key: "day" + (index + 1),
        width: "90px",
        align: "center",
        onCell: (record) => {
          // console.log("oncell render", record);
          let temp = record.timePlanShiftList !== null ? [...record.timePlanShiftList] : []
          temp = temp?.sort?.((a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate))
          // console.log("this temp dayjs", moment(temp[0].effectiveDate, 'YYYY-MM-DD'), temp.filter(o => tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) > 0)?.[0], tempDate, "S");
          let shiftUse = { ...temp.filter(o => tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) >= 0)?.[0] }
          // console.log("shiftUse.shiftId.name", shiftUse.shiftId);
          // console.log("shiftPeriods", shiftUse.shiftId.shiftPeriods.find(o => o.workingDay.code == tempDate.locale("en").format("ddd").toUpperCase()));
          let shiftPeriod = shiftUse?.shiftId?.shiftPeriods?.find(o => o.workingDay.code == tempDate.locale("en").format("ddd").toUpperCase())
          // console.log("!shiftUse?.shiftId?.colorCode", shiftUse?.shiftId?.colorCode);
          return (
            {
              style: {
                backgroundColor: shiftPeriod?.activateDeactivate == 'N' ? '#E5E9F1' : shiftUse?.shiftId?.colorCode ?? "white",
                textAlign: 'center',
                padding: '8px',
                cursor: assignShift.active ? "pointer" : "default"
              }
            })
        },
        render: (_, record) => {
          let temp = record.timePlanShiftList !== null ? [...record.timePlanShiftList] : []
          temp = temp?.sort?.((a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate))
          // console.log("this temp dayjs", moment(temp[0].effectiveDate, 'YYYY-MM-DD'), temp.filter(o => tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) > 0)?.[0], tempDate, "S");
          let shiftUse = { ...temp.filter(o => tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) >= 0)?.[0] }
          // console.log("shiftUse.shiftId.name", shiftUse.shiftId);
          // console.log("shiftPeriods", shiftUse.shiftId.shiftPeriods.find(o => o.workingDay.code == tempDate.locale("en").format("ddd").toUpperCase()));
          let shiftPeriod = shiftUse?.shiftId?.shiftPeriods?.find(o => o.workingDay.code == tempDate.locale("en").format("ddd").toUpperCase())
          let shiftUseId = shiftUse.effectiveDate == tempDate.format("YYYY-MM-DD") ? shiftUse?.shiftId?.id : null
          return (
            <Flex style={{
            }} vertical={true} justify="center" onClick={() => {
              if (assign) {
                // console.log("checkdate ", tempDate.format("YYYY-MM-DD"), shiftUse, shiftUse.effectiveDate == tempDate.format("YYYY-MM-DD"));
                form.setFieldValue("shiftName", shiftUseId)
                form.setFieldValue("shiftStartDate", dayjs(tempDate.format("YYYY-MM-DD")))
                setAssignShift({
                  ...assignShift, title: <Space>{record.employeeName}  {tempDate.locale(i18n.language).format(i18n.language === "th" ? "ddd ,DD MMMM " + (tempDate.year() + 543) : "ddd ,DD MMMM YYYY")}
                  </Space>, open: true, value: { ...record, tempDate, timePlanShiftList: temp, shiftUse, canDelete: shiftUse.effectiveDate == tempDate.format("YYYY-MM-DD") }
                });
              }
              // else {
              //   setOpenDrawer({ ...openDrawer, title: <Space>{record.employeeName} {tempDate.format("ddd ,DD MMMM YYYY")} </Space>, open: true, value: record });
              // }
            }}>
              {/* {tempDate.locale("en").format("ddd").match('Sat|Sun') ? "DAY OFF" : "9.30"} */}
              <span>{shiftPeriod?.activateDeactivate == 'N' ? t("day-off") : null}</span>
              <span>{shiftUse?.shiftId?.name ?? "-"}</span>
            </Flex>
          )
        }
      })
    }
    setColumns([...columnCreate])
  }

  const getShiftOptionsFn = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await getShiftOptions({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      dispatch(setShiftOptions(response.data));
    } catch (error) {
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);

  // console.log("moment", moment().locale('th'));

  const onDateChange = useCallback(
    (e) => {
      console.log("e ", e);
      let dateMoment = moment(e?.format?.('YYYY MM'), "YYYY MM").locale(i18n.language);
      setAssignShift({ ...assignShift, dateActive: e })
      let startMonth = dateMoment.startOf('month').clone()
      // let end = dateMoment.endOf('month').clone()
      console.log("dateMoment", startMonth.format(i18n.language == 'th' ? "dd" : "ddd"));
      // console.log("daysInMonth", dateMoment.daysInMonth());
      calendarCal(dateMoment, assignShift.active)
    },
    [assignShift],
  )

  useEffect(() => {
    setColumns([...columns.map(o => {
      return {
        ...o,
        title: <Space direction="vertical">
          {o?.value?.locale(i18n.language)?.format?.(i18n.language == 'th' ? "dd" : "ddd")}
          {(o.dataIndex)}
        </Space>,
      }
    })])
  }, [i18n.language])

  useEffect(() => {
    if (timePlanShiftByCompany)
      setWorkScheduleList([...timePlanShiftByCompany?.map?.(o => {
        const emp = o?.employee;
        const empNo = emp?.emoloyeeNo ?? emp?.employeeNo;
        const fullName = i18n.language == 'th'
          ? emp?.name + " " + emp?.surName
          : emp?.nameEn + " " + emp?.surNameEn;
        return {
          ...o,
          employeeName: empNo ? `(${empNo}) ${fullName}` : fullName
        }
      })])
  }, [timePlanShiftByCompany, i18n.language])


  const getListOfEmp = useCallback(
    async (params = {}) => {
      try {
        // console.log("currentCompany", currentCompany, currentEmployee);
        dispatch(setIsLoading(true));

        const requestParams = {
          ...params,
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
        }

        if (isShiftHrView) {
          requestParams.roleHr = "Y";
        }
        const response = await getTimePlanShiftByCompany(requestParams);
        dispatch(setTimePlanShiftByCompany(response?.data?.page?.content || []));

        setPagination({
          current: response?.data?.page?.number + 1,
          page: response?.data?.page?.number,
          total: response?.data?.page?.totalElements,
          size: response?.data?.page?.size
        })
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, dispatch, isShiftHrView]
  );
  const getListOfEmpModal = useCallback(
    async (params = {}, cb = () => { }) => {
      try {
        // console.log("currentCompany", currentCompany, currentEmployee);
        dispatch(setIsLoading(true));

        const requestParams = {
          ...params,
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
        }

        if (isShiftHrView) {
          requestParams.roleHr = "Y";
        }
        const response = await getTimePlanShiftByCompany(requestParams);
        // dispatch(setTimePlanShiftByCompany());
        cb(response?.data?.page?.content?.map(o => {
          return { ...o.employee }
        }) || [])
        setPaginationModal({
          current: response?.data?.page?.number + 1,
          page: response?.data?.page?.number,
          total: response?.data?.page?.totalElements,
          size: response?.data?.page?.size
        })
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, dispatch, isShiftHrView]
  );

  const onSearch = useCallback(
    async (params = {}, values) => {
      console.log("🚀 ~ values:", values)
      try {
        dispatch(setIsLoading(true));
        const response = await getTimePlanShiftByCompany({
          ...params,
          roleHr: isShiftHrView ? "Y" : "N",
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
          "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
          "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD"),
          ...values,
        });
        dispatch(setTimePlanShiftByCompany(response?.data?.page?.content || []));
        setPagination({
          current: response?.data?.page?.number + 1,
          total: response?.data?.page?.totalElements,
          size: response?.data?.page?.size
        })
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, assignShift, isShiftHrView]
  );

  const onSearchModal = useCallback(
    async (params = {}, values, cb = () => { }) => {
      console.log("1 values:", values)
      console.log("1 cb:", cb)
      console.log("1 params:", params)
      try {
        dispatch(setIsLoading(true));
        const response = await getTimePlanShiftByCompany({
          ...params,
          roleHr: isShiftHrView ? "Y" : "N",
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
          "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
          "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD"),
          ...values
        });
        console.log("response?.data?.page?.content", response?.data?.page?.content);
        cb(response?.data?.page?.content?.map(o => {
          return { ...o.employee }
        }) || [])
        // dispatch(setTimePlanShiftByCompany(response?.data?.page?.content || []));
        setPaginationModal({
          current: response?.data?.page?.number + 1,
          total: response?.data?.page?.totalElements,
          size: response?.data?.page?.size
        })
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, assignShift, setDataSourceModal, isShiftHrView]
  );
  console.log("dataSourceModal", dataSourceModal);
  const onPageChange = useCallback(
    (tablePagination, tableFilters, tableSorter, tableExtra) => {

      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];

      const modifiedParams = toParams({
        pagination: {
          page: tablePagination?.current - 1,
          size: tablePagination?.pageSize,
          pageSize: tablePagination?.pageSize,
          current: tablePagination.current - 1,
        },
        sortBy: modifiedSorter,
        employeeName: searchName,
        employeeNo: searchNo,
        departmentId: searchDepartment,
        positionId: searchPosition,
        "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
        "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD"),
      });
      getListOfEmp(modifiedParams);
    },
    [getListOfEmp, searchName, searchNo, searchDepartment, searchPosition, assignShift]
  );
  const onPageChangeModal = useCallback(
    (tablePagination, tableFilters, tableSorter, tableExtra) => {

      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];

      const modifiedParams = toParams({
        pagination: {
          page: tablePagination?.current - 1,
          size: tablePagination?.pageSize,
          pageSize: tablePagination?.pageSize,
          current: tablePagination.current - 1,
        },
        sortBy: modifiedSorter,
        employeeName: searchNameModal,
        employeeNo: searchNoModal,
        departmentId: searchDepartmentModal,
        positionId: searchPositionModal,
        // "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
        // "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD"),
      });
      getListOfEmpModal(modifiedParams, setDataSourceModal);
    },
    [getListOfEmpModal, searchName, searchNoModal, searchDepartmentModal, searchPositionModal]
  );

  const handleHrViewChange = useCallback((e) => {
    dispatch(setIsShiftHrView(e.target.checked));
  }, [dispatch]);

  useEffect(() => {
    if (currentCompany && currentEmployee) {
      const params = {
        page: 0,
        size: pagination.size || 10,
      };

      if (assignShift.dateActive) {
        params.startDate = assignShift.dateActive.startOf("month").format("YYYY-MM-DD");
        params.endDate = assignShift.dateActive.endOf("month").format("YYYY-MM-DD");
      } else {
        params.startDate = dayjs().startOf("month").format("YYYY-MM-DD");
        params.endDate = dayjs().endOf("month").format("YYYY-MM-DD");
      }

      if (searchName) params.employeeName = searchName;
      if (searchNo) params.employeeNo = searchNo;
      if (searchDepartment) params.departmentId = searchDepartment;
      if (searchPosition) params.positionId = searchPosition;

      getListOfEmp(params);
    }
  }, [isShiftHrView]);

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language, setLang]);
  useEffect(() => {
    onDateChange(dayjs())

  }, [])

  useMemo(() => {
    console.log("useEffect1");

    if (currentCompany) {
      getShiftOptionsFn()
      getEmployeeTypeOptions({ companyId: currentCompany, groupType: "EMPLOYEE_TYPE" });
      getAttendanceSettingShiftOptions()
    }
    if (currentCompany && currentEmployee) {
      getListOfEmp({
        "startDate": dayjs().startOf("month").format("YYYY-MM-DD"),
        "endDate": dayjs().endOf("month").format("YYYY-MM-DD"),
        page: 0,
        size: 10
      })
    }
  }, [currentCompany, currentEmployee])


  // useMemo(() => {
  //   console.log("useEffect2", assignShift.dateActive);

  //   if (assignShift.dateActive) {
  //     console.log("assignShift.dateActive", assignShift.dateActive);
  //     getListOfEmp({
  //       "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
  //       "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD"),
  //       page: 0,
  //       size: 10
  //     })
  //   }
  // }, [assignShift, assignShift.dateActive])

  useMemo(() => {
    if (assignShift.dateActive) {
      onDateChange(assignShift.dateActive)
      // calendarCal(assignShift.dateActive, assignShift.active)  
    }
  }, [assignShift.active, assignShift.dateActive])



  // useEffect(() => {
  //   getListOfEmp({
  //     "startDate": "2024-06-01",
  //     "endDate": "2024-06-30"
  //   })
  // }, [])



  const createTimePlanShiftFn = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));
        const response = await createTimePlanShift({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params.employeeId,
          actionId: currentEmployee,
          shiftId: params.shiftId,
          startDate: params.startDate.format("YYYY-MM-DD"),
        });
        // console.log("createTimePlanShiftFn assignShift.dateActive", assignShift.dateActive);
        onDateChange(assignShift.dateActive)
        getListOfEmp({
          ...pagination,
          "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
          "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD"),
        })
        setAssignShift({ ...assignShift, open: false });
        form.resetFields();
        if (response?.data?.status?.details[0]?.key === "ErrorTH") {
          Modal.error({
            content: i18n.language === "en" ? response?.data?.status?.details[1]?.value : response?.data?.status?.details[0]?.value,
            okText: t("message.ok")
          })
        } else {
          message.success(t("common.success"))
        }
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, assignShift, assignShift.dateActive, dispatch, i18n.language, pagination]
  );

  const deleteTimePlanShiftFn = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));
        const response = await deleteTimePlanShift({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params.employeeId,
          actionId: currentEmployee,
          timePlanShiftId: params.timePlanShiftId,
        });
        // setModalOpen(false);
        onDateChange(assignShift.dateActive)

        getListOfEmp({
          "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
          "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD")
        })
        setAssignShift({ ...assignShift, open: false });
        form.resetFields();
        message.success(t("common.success"))
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, assignShift, assignShift.dateActive, dispatch]
  );

  async function deleteTimePlanShiftFnList(list) {
    list.forEach(async o => {
      let data = {
        employeeId: assignShift?.value?.employee?.id,
        timePlanShiftId: o.timeplanshiftId
      }
      await deleteTimePlanShiftFn(data)
    });
    return "OK"
  }

  const updateTimePlanShiftFn = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));
        const response = await updateTimeplanShift({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params.employeeId,
          actionId: currentEmployee,
          shiftId: params?.shiftId,
          startDate: params?.startDate?.format("YYYY-MM-DD"),
          timePlanShiftId: params?.timePlanShiftId,
        });
        // setModalOpen(false);
        onDateChange(assignShift.dateActive)
        getListOfEmp({
          ...pagination,
          "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
          "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD")
        })
        setAssignShift({ ...assignShift, open: false });
        form.resetFields();
        message.success(t("common.success"))
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, assignShift, assignShift.dateActive, dispatch]
  );
  const updateTimePlanShiftAllFn = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));
        const response = await updateTimePlanShiftAll({
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: params.employeeId,
          employeeIds: params.employeeIds,
          actionId: currentEmployee,
          shiftId: params?.shiftId,
          startDate: params?.startDate?.format("YYYY-MM-DD"),
          endDate: params?.endDate?.format("YYYY-MM-DD"),
          timePlanShiftId: params?.timePlanShiftId,
        });
        // setModalOpen(false);
        // onDateChange(assignShift.dateActive)
        getListOfEmp({
          ...pagination,
          "startDate": assignShift.dateActive.startOf("month").format("YYYY-MM-DD"),
          "endDate": assignShift.dateActive.endOf("month").format("YYYY-MM-DD")
        })
        setAssignShift({ ...assignShift, open: false });
        form.resetFields();
        message.success(t("common.success"))
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, currentEmployee, assignShift, assignShift.dateActive, dispatch]
  );



  const onFinish = async () => {
    console.log("onfinish ", assignShift);
    let shiftName = form.getFieldValue("shiftName")
    let temp = [...assignShift?.value?.timePlanShiftList]
    temp = temp?.sort?.((a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate))
    // console.log("this temp dayjs", moment(temp[0].effectiveDate, 'YYYY-MM-DD'), temp.filter(o => tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) > 0)?.[0], tempDate, "S");
    let shiftUse = { ...temp.filter(o => assignShift.value.tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) >= 0)?.[0] }
    console.log("shiftUse", form.getFieldsValue(), shiftUse, shiftUse?.shiftId?.id);
    let shiftStartDate = null;
    let shiftEndDate = null;
    if (!form.getFieldValue("haveEndDate")) {
      shiftStartDate = form.getFieldValue("shiftStartDate")
    } else {
      shiftStartDate = form.getFieldValue("shiftStartDate")?.[0]
      shiftEndDate = form.getFieldValue("shiftStartDate")?.[1]
    }
    let data = {
      shiftId: shiftUse?.shiftId?.id,
      shiftStartDate,
      shiftEndDate
    }

    if (!form.getFieldValue("haveEndDate")) {
      if (assignShift?.value?.canDelete) {
        updateTimePlanShiftFn({
          timePlanShiftId: shiftUse.timeplanshiftId,
          shiftId: shiftName,
          employeeId: assignShift?.value?.employee?.id,
          startDate: shiftStartDate
        })
      } else {
        createTimePlanShiftFn({
          timePlanShiftId: shiftUse.timeplanshiftId,
          shiftId: shiftName,
          employeeId: assignShift?.value?.employee?.id,
          startDate: shiftStartDate
        })
      }
    } else {
      //  temp.filter(o => assignShift.value.tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) > = 0)
      console.log("shiftStartDate,shiftEndDate", shiftStartDate, shiftEndDate);
      let dataListDelete = [...temp.filter(o => shiftStartDate?.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) < 0 && shiftEndDate?.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) > 0)]
      console.log("dataListDelete", dataListDelete);
      let dataListUpdate = [...temp.filter(o => shiftStartDate?.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) == 0 || shiftEndDate?.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) == 0)]
      let isOk = await deleteTimePlanShiftFnList(dataListDelete)
      console.log("dataListUpdate.some(shiftStartDate)",);
      dataListUpdate.forEach(async o => {
        updateTimePlanShiftFn({
          timePlanShiftId: shiftUse.timeplanshiftId,
          shiftId: shiftName,
          employeeId: assignShift?.value?.employee?.id,
          startDate: dayjs(o.effectiveDate, 'YYYY-MM-DD')
        })
      })
      if (isOk) {
        console.log("isOk", isOk);
        if (!dataListUpdate.some(o => o.effectiveDate == shiftStartDate.format("YYYY-MM-DD"))) {
          await createTimePlanShiftFn({
            shiftId: shiftName,
            employeeId: assignShift?.value?.employee?.id,
            startDate: shiftStartDate
          })
        }
        if (!dataListUpdate.some(o => o.effectiveDate == shiftEndDate.format("YYYY-MM-DD"))) {
          await createTimePlanShiftFn({
            shiftId: shiftUse?.shiftId?.id ?? shiftName,
            employeeId: assignShift?.value?.employee?.id,
            startDate: shiftEndDate.clone().add(1, 'day')
          })
        }
      }
    }
  }
  const onFinishModal = async () => {
    let shiftName = form.getFieldValue("shiftName")
    // console.log("this temp dayjs", moment(temp[0].effectiveDate, 'YYYY-MM-DD'), temp.filter(o => tempDate.diff(moment(o.effectiveDate, 'YYYY-MM-DD')) > 0)?.[0], tempDate, "S");
    let shiftStartDate = null;
    let shiftEndDate = null;
    if (!form.getFieldValue("haveEndDate")) {
      shiftStartDate = form.getFieldValue("shiftStartDate")
    } else {
      shiftStartDate = form.getFieldValue("shiftStartDate")?.[0]
      shiftEndDate = form.getFieldValue("shiftStartDate")?.[1]
    }
    console.log("selectedRowKeys", selectedRowKeys, selectedRowKeys.map(o => o.id));
    updateTimePlanShiftAllFn({
      shiftId: shiftName,
      employeeIds: selectedRowKeys.map(o => o.id),
      startDate: shiftStartDate,
      endDate: shiftEndDate,
    })
    setOpenAll(false)
    setSelectedRowKeys([])
    setDataSourceModal([])
    setPaginationModal({ page: 0, size: 10 })
  }

  const onClose = () => {
    setOpenDrawer({ ...openDrawer, open: false });
  };

  const Drower = useCallback(
    () => {
      return (
        < Drawer destroyOnClose={true} title={openDrawer?.title} onClose={onClose} open={openDrawer.open} ></Drawer>
      )
    },
    [onClose, openDrawer],
  )
  const formItemLayout = {
    labelAlign: "left",
    labelCol: { span: 6 },
  };

  function localeFn() {
    if (i18n.language === 'en') {
      return localeEn
    } else {
      return {
        ...localeTh,
        lang: {
          ...localeTh.lang,
          yearFormat: "BBBB",
          dateFormat: "D/M/BBBB",
          cellYearFormat: "BBBB"
        }
      }
    }
  }

  const ModalEdit = useCallback(
    () => {
      return (
        <Modal
          closable={false}
          maskClosable={false}
          footer={() => {
            return (
              <Row justify={"space-between"} style={{ marginTop: "24px" }}>
                <Col span={4} >
                  <Button
                    style={{
                      display: assignShift?.value?.canDelete ? "inline" : "none",
                      height: "40px", borderRadius: "8px"
                    }}
                    onClick={() => {
                      console.log("setAssignShift close", assignShift);
                      let timePlanShiftId = assignShift?.value?.timePlanShiftList?.find(o => o.effectiveDate == assignShift.value.tempDate.format("YYYY-MM-DD"))
                      console.log("timePlanShiftId", timePlanShiftId);
                      let data = {
                        employeeId: assignShift?.value?.employee?.id,
                        timePlanShiftId: timePlanShiftId?.timeplanshiftId
                      }
                      deleteTimePlanShiftFn(data)
                      // setAssignShift({ ...assignShift, open: false });
                      // form.resetFields();
                    }}
                  >
                    {t('team.label.reset')}
                  </Button>
                </Col>
                <Col span={12}>
                  <Space direction="horizontal" size={12}>
                    <Button
                      onClick={() => {
                        console.log("setAssignShift close", assignShift);
                        setAssignShift({ ...assignShift, open: false });
                        form.resetFields();
                      }}
                      style={{ borderRadius: "8px", height: "40px" }}
                      type="default"
                    >
                      {t("common.cancel")}
                    </Button>
                    <Button
                      onClick={() => {
                        form.submit();
                        form.scrollToField("shiftEndDate");
                        console.log("form", assignShift, form.getFieldValue("shiftStartDate"));
                      }}
                      style={{ backgroundColor: "var(--button-color)", color: "var(--button-text-color)", borderRadius: "8px", height: "40px" }}
                      type="primary"
                    >
                      {t("common.submit")}
                    </Button>
                  </Space>
                </Col>
              </Row>
            )
          }
          }
          destroyOnClose={true}
          title={assignShift?.title}
          onCancel={() => {
            console.log("setAssignShift close", assignShift);
            setAssignShift({ ...assignShift, open: false })
            form.resetFields()
          }}
          open={assignShift.open}
        // onOk={(e) => {
        //   form.submit()
        //   form.scrollToField("shiftEndDate")
        //   console.log("form", assignShift, form.getFieldValue("shiftStartDate"));
        // }}
        >
          <Form
            {...formItemLayout}
            colon={false}
            form={form} onFinish={onFinish} initialValues={{
              // shiftName: assignShift?.value?.shiftUseId,
              // shiftStartDate: dayjs(assignShift?.value?.tempDate.format("YYYY-MM-DD")),
              IsEndShift: false
            }}
            requiredMark={(label, { required }) => {
              if (required) {

                return (
                  <Flex>
                    {label}
                    {<span style={{ color: "red" }}>*</span>}
                  </Flex>)
              } else {
                return label
              }
            }
            }
            style={{ marginTop: "24px" }}
          >
            <Form.Item shouldUpdate  {...formItemLayout}>
              {({ getFieldValue, setFieldValue }) => {
                return (<Row gutter={[0, 5]}>
                  <Col span={24}>
                    <Form.Item
                      name="shiftName"
                      label={t("team.label.shift-name")}
                      rules={[{
                        required: true,
                      }]}
                      colon={false}
                      {...formItemLayout}
                    >
                      <Select allowClear placeholder={t("team.label.please-select-shift")} popupMatchSelectWidth={false} options={shiftOptions?.map((opt) => ({
                        ...opt,
                        label: i18n.language == "en" ? opt.nameEn : opt.name,
                        value: opt.id,
                      }))} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item labelAlign="" {...formItemLayout} label={t("team.label.have-end-date")} name={"haveEndDate"}>
                      <Checkbox
                        // disabled={!assignShift?.value?.shiftUse?.shiftId} 
                        onChange={(e) => {
                          setFieldValue("haveEndDate", e.target.checked)
                          setFieldValue("shiftStartDate", dayjs(assignShift?.value?.tempDate.format("YYYY-MM-DD")))
                        }}>
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      colon={false}
                      name="shiftStartDate"
                      label={t("team.label.shift-start-date")}
                      {...formItemLayout}
                    >
                      {!getFieldValue("haveEndDate") && <DatePicker defaultValue={dayjs(assignShift?.value?.tempDate.format("YYYY-MM-DD"))} format={i18n.language === "th" ? "DD/MM/BBBB" : "DD/MM/YYYY"} disabled />}
                      {getFieldValue("haveEndDate") &&
                        <RangePicker
                          disabled={[true, false]}
                          format={i18n.language === "th" ? "DD/MM/BBBB" : "DD/MM/YYYY"}
                          defaultValue={dayjs(assignShift?.value?.tempDate.format("YYYY-MM-DD"))}
                          minDate={dayjs(assignShift?.value?.tempDate.format("YYYY-MM-DD"))}
                          placeholder={[t("start-date"), t("end-date")]}
                          style={{ width: "100%" }}
                          locale={localeFn()}
                        />}
                    </Form.Item>
                  </Col>
                </Row>)
              }}
            </Form.Item>
          </Form>
        </Modal>
      )
    },
    [assignShift, i18n.language],
  )

  const ModalEditAll = useCallback(
    () => {
      console.log("openAll", openAll);
      return (
        <Modal
          width={"100em"}
          // styles={{
          //   content: {
          //     width: "100vh",
          //     maxInlineSize: "max-content"
          //   }
          // }}
          closable={false}
          maskClosable={false}
          footer={() => {
            return (
              <Row justify={"space-between"} style={{ marginTop: "24px" }}>
                <Col span={4} >
                  {/* <Button
                    style={{
                      display: assignShift?.value?.canDelete ? "inline" : "none",
                      height: "40px", borderRadius: "8px"
                    }}
                    onClick={() => {
                      console.log("setAssignShift close", assignShift);
                      let timePlanShiftId = assignShift?.value?.timePlanShiftList?.find(o => o.effectiveDate == assignShift.value.tempDate.format("YYYY-MM-DD"))
                      console.log("timePlanShiftId", timePlanShiftId);
                      let data = {
                        employeeId: assignShift?.value?.employee?.id,
                        timePlanShiftId: timePlanShiftId?.timeplanshiftId
                      }
                      deleteTimePlanShiftFn(data)
                      // setAssignShift({ ...assignShift, open: false });
                      console.log("set false");
                      setOpenAll(false);
                      setDataSourceModal([])
                      setSelectedRowKeys([])
                      setDateModal(null)
                      setDateListModal(null)
                      form.resetFields();
                    }}
                  >
                    {t('team.label.reset')}
                  </Button> */}
                </Col>
                <Col span={12}>
                  <Space direction="horizontal" size={12}>
                    <Button
                      onClick={() => {
                        // setAssignShift({ ...assignShift, open: false });
                        setOpenAll(false)
                        setSelectedRowKeys([])
                        setDataSourceModal([])
                        setPaginationModal({ page: 0, size: 10 })
                        form.resetFields();
                      }}
                      style={{ borderRadius: "8px", height: "40px" }}
                      type="default"
                    >
                      {t("common.cancel")}
                    </Button>
                    <Button
                      onClick={() => {
                        form.submit();
                        form.scrollToField("shiftEndDate");
                        console.log("form", assignShift, form.getFieldValue("shiftStartDate"));
                      }}
                      style={{ backgroundColor: "var(--button-color)", color: "var(--button-text-color)", borderRadius: "8px", height: "40px" }}
                      type="primary"
                    >
                      {t("common.submit")}
                    </Button>
                  </Space>
                </Col>
              </Row>
            )
          }
          }
          destroyOnClose={true}
          // title={assignShift?.title}
          onCancel={() => {
            // setAssignShift({ ...assignShift, open: false })
            setOpenAll(false)
            setSelectedRowKeys([])
            setDataSourceModal([])
            setPaginationModal({ page: 0, size: 10 })
            form.resetFields()
          }}
          open={openAll}
        // onOk={(e) => {
        //   form.submit()
        //   form.scrollToField("shiftEndDate")
        //   console.log("form", assignShift, form.getFieldValue("shiftStartDate"));
        // }}
        >
          <Form
            {...formItemLayout}
            colon={false}
            form={form} onFinish={onFinishModal} initialValues={{
              // shiftName: assignShift?.value?.shiftUseId,
              // shiftStartDate: dayjs(assignShift?.value?.tempDate.format("YYYY-MM-DD")),
              IsEndShift: false
            }}
            requiredMark={(label, { required }) => {
              if (required) {

                return (
                  <Flex>
                    {label}
                    {<span style={{ color: "red" }}>*</span>}
                  </Flex>)
              } else {
                return label
              }
            }
            }
            style={{ marginTop: "24px" }}
          >
            <Form.Item shouldUpdate  {...formItemLayout}>
              {({ getFieldValue, setFieldValue }) => {
                return (<Row gutter={[0, 5]}>
                  <Col span={24}>
                    <Form.Item
                      name="shiftName"
                      label={t("team.label.shift-name")}
                      rules={[{
                        required: true,
                      }]}
                      colon={false}
                      {...formItemLayout}
                    >
                      <Select allowClear placeholder={t("team.label.please-select-shift")} popupMatchSelectWidth={false} options={shiftOptions?.map((opt) => ({
                        ...opt,
                        label: i18n.language == "en" ? opt.nameEn : opt.name,
                        value: opt.id,
                      }))} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item labelAlign="" {...formItemLayout} label={t("team.label.have-end-date")} name={"haveEndDate"}>
                      <Checkbox
                        // disabled={!assignShift?.value?.shiftUse?.shiftId} 
                        onChange={(e) => {
                          console.log("haveEndDate", e.target.checked);
                          setFieldValue("haveEndDate", e.target.checked)
                          if (e.target.checked) {
                            setDateListModal(null)
                          } else {
                            setDateModal(null)
                          }

                          // setFieldValue("shiftStartDate", dayjs(assignShift?.value?.tempDate.format("YYYY-MM-DD")))
                        }}>
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      colon={false}
                      required
                      name="shiftStartDate"
                      label={t("team.label.shift-start-date")}
                      {...formItemLayout}
                    >
                      {!getFieldValue("haveEndDate") && <DatePicker
                        defaultValue={dateModal ?? null}
                        locale={localeFn()}
                        format={i18n.language === "th" ? "DD/MM/BBBB" : "DD/MM/YYYY"} onChange={(date) => {
                          setDateModal(date)
                        }} />}
                      {getFieldValue("haveEndDate") &&
                        <RangePicker
                          disabled={[false, false]}
                          format={i18n.language === "th" ? "DD/MM/BBBB" : "DD/MM/YYYY"}
                          defaultValue={dateListModal}
                          // minDate={dateListModal?.[0]}
                          placeholder={[t("start-date"), t("end-date")]}
                          style={{ width: "100%" }}
                          locale={localeFn()}
                          onChange={setDateListModal}
                        />}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      colon={false}
                      name="employee"
                      // label={t("team.label.shift-start-date")}
                      {...formItemLayout}
                    >
                      <Card style={{ border: "solid 1px #EAECF0" }}>
                        <Space direction="vertical">
                          <WorkscheduleFilterModal
                            departmentOptions={modifiedDepartmentOptions}
                            positionOptions={modifiedPositionOptions}
                            employeeTypeOptions={employeeTypeOptions}
                            attendanceSettingShift={modifiedAttendanceSettingShift}
                            setSearchName={setSearchNameModal}
                            setSearchNo={setSearchNoModal}
                            setSearchDepartment={setSearchDepartmentModal}
                            setSearchPosition={setSearchPositionModal}
                            setDataSourceModal={setDataSourceModal}
                            // dataFlag={pendingTab}
                            // leaveGroupOptions={modifiedLeaveGroupOptions}
                            // companyRegulationOptions={modifiedCompanyRegulationOptions}
                            // employeeOptions={modifiedEmployeeOptions}
                            // penaltiesOptions={modifiedPenaltiesOptions}
                            // offsiteOptions={modifiedOffSiteOptions}
                            onSubmit={onSearchModal}
                          />
                          <Space style={{
                            alignItems: "flex-start"
                          }} styles={{
                            item: {
                              minWidth: "45.5em"
                            }
                          }}>
                            <TableAntd onChange={onPageChangeModal} pagination={paginationModal} rowKey={(record) => record?.id} rowSelection={{
                              selectedRowKeys: (selectedRowKeys.map(o => o.id)),
                              onSelect: onSelectChange,
                              onSelectAll: onSelectChangeAll,
                            }} columns={[{
                              title: <div className="text-table">{t('salary.label.employee_no')}</div>,
                              dataIndex: "id",
                              key: "id",
                              width: "200px",
                              fixed: "left",
                              render: (_, record) => {
                                console.log("record", _, record);
                                return record?.emoloyeeNo
                              }
                            },
                            {
                              title: <div className="text-table">{t('employee.header')}</div>,
                              dataIndex: "name",
                              key: "name",
                              width: "200px",
                              fixed: "left",
                              render: (_, record) => {
                                return record?.name + " " + record?.surName
                              }
                            },
                            {
                              title: <div className="text-table">{t('employee.label.department')}</div>,
                              dataIndex: "departmentName",
                              key: "departmentName",
                              width: "200px",
                              fixed: "left",
                              // render: (_, record) => {
                              //   return record?.name + " " + record?.surName
                              // }
                            },
                            {
                              title: <div className="text-table">{t('employee.label.position')}</div>,
                              dataIndex: "positionName",
                              key: "positionName",
                              width: "200px",
                              fixed: "left",
                              // render: (_, record) => {
                              //   return record?.name + " " + record?.surName
                              // }
                            }
                            ]} dataSource={dataSourceModal} >
                            </TableAntd>
                            <TableAntd rowKey={(record) => record?.id} rowSelection={{
                              selectedRowKeys: (selectedRowKeys.map(o => o.id)),
                              onSelect: onSelectChange,
                              onSelectAll: onSelectChangeAll,
                            }} columns={[{
                              title: <div className="text-table">{t('salary.label.employee_no')}</div>,
                              dataIndex: "id",
                              key: "id",
                              width: "200px",
                              fixed: "left",
                              render: (_, record) => {
                                console.log("record", _, record);
                                return record?.emoloyeeNo
                              }
                            },
                            {
                              title: <div className="text-table">{t('employee.header')}</div>,
                              dataIndex: "name",
                              key: "name",
                              width: "200px",
                              fixed: "left",
                              render: (_, record) => {
                                return record?.name + " " + record?.surName
                              }
                            },
                            {
                              title: <div className="text-table">{t('employee.label.department')}</div>,
                              dataIndex: "departmentName",
                              key: "departmentName",
                              width: "200px",
                              fixed: "left",
                              // render: (_, record) => {
                              //   return record?.name + " " + record?.surName
                              // }
                            },
                            {
                              title: <div className="text-table">{t('employee.label.position')}</div>,
                              dataIndex: "positionName",
                              key: "positionName",
                              width: "200px",
                              fixed: "left",
                              // render: (_, record) => {
                              //   return record?.name + " " + record?.surName
                              // }
                            }
                            ]} dataSource={selectedRowKeys} ></TableAntd>
                          </Space>
                        </Space>
                      </Card>

                    </Form.Item>
                  </Col>
                </Row>)
              }}
            </Form.Item>
          </Form>
        </Modal >
      )
    },
    [openAll, i18n.language, dataSourceModal, setOpenAll, selectedRowKeys, paginationModal
      , dateModal
      , dateListModal],
  )

  const onAssignShift = () => {
    console.log("call , onAssignShift");
    setAssignShift({ ...assignShift, active: !assignShift.active })
  }

  return {
    columns,
    workScheduleList,
    modifiedDepartmentOptions,
    modifiedPositionOptions,
    employeeTypeOptions,
    modifiedAttendanceSettingShift,
    onDateChange,
    onAssignShift,
    Drower,
    onSearch,
    ModalEdit,
    assignShift,
    setSearchName,
    setSearchNo,
    setSearchDepartment,
    setSearchPosition,
    onPageChange,
    pagination,
    isShiftHrView,
    handleHrViewChange,
    ModalEditAll,
    setOpenAll
  };
}

export default useMyTeamWorkSchedule;
